import { MagnifyingGlassIcon } from "@radix-ui/react-icons";
import { TextField } from "@radix-ui/themes";
import { useCallback, useState } from "react";
import { useDebouncedCallback } from "@/lib/useDebouncedCallback";
interface ExploreSearchProps {
  search: string;
  onSearchChanged: (search: string) => void;
}

export function ExploreSearch({ search, onSearchChanged }: ExploreSearchProps) {
  const [searchValue, setSearchValue] = useState(search);

  const debouncedSearch = useDebouncedCallback(onSearchChanged, 700);

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setSearchValue(e.target.value);
      debouncedSearch(e.target.value);
    },
    [debouncedSearch]
  );

  return (
    <TextField.Root
      placeholder="Search…"
      size="2"
      value={searchValue}
      onChange={handleSearchChange}
    >
      <TextField.Slot>
        <MagnifyingGlassIcon height="16" width="16" />
      </TextField.Slot>
    </TextField.Root>
  );
}
